import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { CircularProgress, Box, Typography } from '@mui/material';
import axiosInstance from '../utils/axiosConfig';
import NavigatorApplicantDetailPage from './NavigatorApplicantDetailPage';
import Navigator2026ApplicantDetailPage from './Navigator2026ApplicantDetailPage';
import BanBamApplicantDetailPage from './BanBamApplicantDetailPage';

const ApplicationRouter: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [formType, setFormType] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchFormType = async () => {
      try {
        const response = await axiosInstance.get(`/api/applications/submissions/${id}`);
        setFormType(response.data.formType);
      } catch (err: any) {
        setError(err.message || 'Error loading application');
      } finally {
        setLoading(false);
      }
    };

    fetchFormType();
  }, [id]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  // Route to the appropriate detail page based on form type
  if (formType?.includes('navigator-2026')) {
    return <Navigator2026ApplicantDetailPage />;
  }

  if (formType?.includes('navigator')) {
    return <NavigatorApplicantDetailPage />;
  }

  if (formType?.includes('banbam')) {
    return <BanBamApplicantDetailPage />;
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography>Unknown form type: {formType}</Typography>
    </Box>
  );
};

export default ApplicationRouter;